module.exports = __webpack_public_path__ + "static/fifty-wooden-boats-902fd840f355e6140ef9f26b3b5b50a6.jpg";